  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="AddStockTakeShipmentOtherModal" ref="modal" title="Add Shipment (Other)" ok-title="Submit" cancel-title="Close" 
     @show = "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddShipmentOtherForm != undefined ? !this.$refs.AddShipmentOtherForm.checkValidity() : true">
        <form ref="AddShipmentOtherForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-6">
               <b-form-group  label="Shipment Date" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "ShipmentDate" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class = "col-md-6">
              <b-form-group  label="Voucher No" label-for="voucherno" autocomplete="off">
                <b-form-input id="voucherno" v-model= "VoucherNo"  required></b-form-input>
              </b-form-group>
            </div>
            <div class = "col-md-6">
              <b-form-group  label="Truck No" label-for="truckno" autocomplete="off">
                <b-form-input id="truckno" v-model= "TruckNo"  required ></b-form-input>
              </b-form-group>
            </div>
           
            <div class="col-md-6">
              <b-form-group label="Client" label-for="Client" autocomplete="off">
                <b-form-select v-model= "SelectedClientId" :options="clientsList" value-field="id" text-field="companyName" required>
                  <b-form-select-option :value = null disabled hidden>Select Client</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
              
              <div class="col-md-6">
                <b-form-group label="Product" label-for="Product" autocomplete="off">
               <b-form-input id="flourtype" v-model= "flourObject.flourName" type = "text" disabled></b-form-input>                 
                </b-form-group>
            </div>
             <div class="col-md-6">
              <b-form-group label="Bag Type" label-for="BagType" autocomplete="off">
                <b-form-input id="flourweight" v-model= "flourObject.flourWeight" type = "text" disabled></b-form-input>              
              </b-form-group>
            </div>
           
             <div class = "col-md-6">
              <b-form-group  label="No Of Sacks" label-for="sacks" autocomplete="off">
                <b-form-input id="sacks" v-model= "NoOfSacks" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
             <div class = "col-md-6">
              <b-form-group  label="Unit Price" label-for="FlourUnitPrice" autocomplete="off">
                <b-form-input id="FlourUnitPrice" v-model= "FlourUnitPrice"  required></b-form-input>
              </b-form-group>
            </div>
          </div>
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
      </div>
      </template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'AddShipmentOther',
    mounted()
    {
      
      this.getClients();
     
      // console.log(this.$auth.user())
    },
    components:{
      Toaster
    },
    data(){
        return{
          moduleName:'Add Shipment (Other)',   
          ShipmentDate:null,

          VoucherNo: null,
          TruckNo : null,
          NoOfSacks: 1,
          SelectedClientId:null,
          clientsList:[],
          FlourUnitPrice:0,
         

        shipmentEntries:[]
     
		}
  },
  props:{
    flourObject:{
      type:Object,
      default:null
    },
    isAdjustment:{
      type:Boolean,
      default:false
    }
  },
methods:{
  getClients()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            
          }
          axios.post('/client/getall', model)
          .then(res=>{
         
            this.clientsList = res.data.data
          });
   },

   AddShipmentOther(){ 
      this.shipmentEntries = [];
      
       let shipmentEntryModel = {
      NoOfSacks:parseFloat(this.NoOfSacks),
      FlourTypeId:this.flourObject.flourId,
      FlourWeightId:this.flourObject.flourWeightId,
      FlourUnitPrice:parseFloat(this.FlourUnitPrice)
    }
    this.shipmentEntries.push(shipmentEntryModel);

      let model = {
      "IsInventoryTransaction":true, //private entries has inventory only transactions
      "ShipmentDate":this.ShipmentDate,
      "VoucherNo":this.VoucherNo,
      "TruckNo":this.TruckNo,
      "ClientId":this.SelectedClientId,
      "ShipmentEntries":this.shipmentEntries,
      "IsAdjustmentEntry":this.isAdjustment,
      "IsStockTakeEntry":true,
      "CompanyId":this.$auth.user().companyId,
      "UserId":this.$auth.user().id
      }
      console.log(this.shipmentEntries);
     axios.post('/shipment/PrivateAdd', model
      )
      .then(res=>{
      
            if(res.data.status == 1)
            {    
                 this.$refs.toaster.showToast('Sucess','success','Shipment has been added successfully')
                this.$bvModal.hide('AddStockTakeShipmentOtherModal');
              this.$parent.MarkEntryAsDone(this.flourObject.flourWeightTypeLinkId);
            }
            else
            {
               this.$refs.toaster.showToast('Error','danger',res.data.msg);
              
            }
           
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddShipmentOtherForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      updateModal()
      {
        this.ShipmentDate = new Date();
           this.FlourUnitPrice = 0;
          this. shipmentEntries=[];
           this.VoucherNo= null
           this. TruckNo = null
           this.NoOfSacks= 1
           this.SelectedClientId=null
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.AddShipmentOther()
       
        // this.$nextTick(() => {
        //   //this.$router.go('/phones')
        //   this.$bvModal.hide('AddShipmentOtherdModal')
        
        // })
      },

 

  }
	

}
</script>
